export default "assets/images/logo-82516cee.svg";